import { render } from "./listDetails.vue?vue&type=template&id=176a6f96&scoped=true"
import script from "./listDetails.vue?vue&type=script&lang=js"
export * from "./listDetails.vue?vue&type=script&lang=js"

import "./listDetails.vue?vue&type=style&index=0&id=176a6f96&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_269ca4a85a7eca3d5d7c9cc630d4bd5a/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-176a6f96"]])

export default __exports__